/**
 * Request model for paginated dashboard endpoints
 */
export interface IDashboardRequest {
    pageNumber: number;
    pageSize: number;
    searchTerm?: string;
    sortColumn?: string;
    sortDirection?: string;
    activeFlag?: string;
    isDraftMode: boolean;
    columnFilters?: { [key: string]: string };
}

/**
 * Response model for paginated results
 */
export interface IPaginatedResult<T> {
    data: T[];
    totalRecords: number;
    pageNumber: number;
    pageSize: number;
    searchTerm?: string;
    sortColumn?: string;
    sortDirection?: string;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

/**
 * Creates a default dashboard request
 */
export function createDefaultDashboardRequest(isDraftMode: boolean = false): IDashboardRequest {
    return {
        pageNumber: 1,
        pageSize: 25,
        searchTerm: '',
        sortColumn: '',
        sortDirection: 'DESC',
        activeFlag: 'A',
        isDraftMode: isDraftMode,
        columnFilters: {}
    };
}
